import { useMemo } from 'react';
import { Job, Stop, StopType } from '../apis/dtos';

export const useShipmentDetailsData = (shipment: Job) => {
  const sortedStops = useMemo(
    () =>
      [...shipment.stops]?.sort((a, b) => a.sequenceNumber - b.sequenceNumber),
    [shipment.stops]
  );

  const pickup = useMemo(
    () =>
      sortedStops.find(
        (stop) =>
          stop.stopType === StopType.Pick ||
          stop.stopType === StopType.OriginAirport ||
          stop.stopType === StopType.OriginPort
      ) ?? ({} as Stop),
    [sortedStops]
  );

  const deliverTo = useMemo(
    () =>
      sortedStops
        .filter(
          (stop) =>
            stop.stopType === StopType.Drop ||
            stop.stopType === StopType.DestinationAirport ||
            stop.stopType === StopType.DestinationPort
        )
        .pop() ?? ({} as Stop),
    [sortedStops]
  );

  return {
    pickup,
    deliverTo,
  };
};
